import React from "react"
import parse from 'html-react-parser';
import SignatureCanvas from "react-signature-canvas";
import { FormHelperText, Grid, Typography } from "@mui/material";
import { handleImageError } from "../../helpers/imageErrorHandler";


export default function Contract(props: any) {
	const { membershipTerms, clubData, refs, errors } = props;
	const membershipInfo: any = unescapeHTML(membershipTerms.membershipInfo);
	const memberInfo: any = unescapeHTML(membershipTerms.memberInfo);
	const paymentInfo: any = unescapeHTML(membershipTerms.paymentInfo);
	const cancelTerms: any = unescapeHTML(membershipTerms.cancellationTerms);
	const legalTerms: any = unescapeHTML(membershipTerms.legalTerms);

	function unescapeHTML(escapedHTML: any) {
		const html = escapedHTML
			.replace(/&lt;br\/&gt;/g, "")
			.replace(/(\r\n|\n|\r)/gm, "<br/>");
		return parse(html);
	}
	const sigPad: any = {
		width: "100%",
		height: "200px",
		border: "1px solid black",
	};
	return (
		<div>
			<Grid container sx={{justifyContent: "space-between"}}>
				<Grid>
					{clubData.logoPath && (
						<img src={clubData?.logoPath} width={120} alt="logo" onError={handleImageError} />
					)}
				</Grid>
				<Grid>
					<Typography align="right" variant="subtitle2">
						{clubData?.clubName}
						<br />
						{clubData?.address}
						<br />
						{clubData?.city} {clubData?.state}, {clubData?.country}
					</Typography>
				</Grid>
			</Grid>
			<br />
			{memberInfo}
			{membershipInfo}
			{paymentInfo}
			Member Signature:
			<SignatureCanvas
				ref={refs.sigCanvas}
				penColor="black"
				canvasProps={{
					style: sigPad,
				}}
			/>
			{errors.sig1 ? (
				<FormHelperText style={{ color: "red" }}>{errors.sig1}</FormHelperText>
			) : null}
			<br />
			<br />
			{cancelTerms}
			Member Signature:
			<SignatureCanvas
				ref={props.refs.sigCanvas2}
				penColor="black"
				canvasProps={{
					style: sigPad,
				}}
			/>
			{errors.sig2 ? (
				<FormHelperText style={{ color: "red" }}>{errors.sig2}</FormHelperText>
			) : null}
			<br />
			<br />
			{legalTerms}
			Member Signature:
			<SignatureCanvas
				ref={props.refs.sigCanvas3}
				penColor="black"
				canvasProps={{
					style: sigPad,
				}}
			/>
			{errors.sig3 ? (
				<FormHelperText style={{ color: "red" }}>{errors.sig3}</FormHelperText>
			) : null}
			<br />
			<br />
		</div>
	);
}
